import * as s from "react";
import { useContext as W, useMemo as le, useState as ce, useRef as ue } from "react";
import { a as q, q as G, s as Z, g as fe, m as de, O as pe, j as J, v as me, o as ee, Q as te } from "./index-CjjiqU7h.mjs";
import { F as L } from "./context-CqAjIyj3.mjs";
import { u as ve, i as ge, a as Ce, g as ye } from "./index-DIiEiQf8.mjs";
import { I as U, u as be, d as Oe } from "./style-B5VBq8yY.mjs";
import { p as he } from "./pickAttrs-bNG7_x1p.mjs";
import { a as Ee } from "./useCSSVarCls--o7XUl-F.mjs";
import { u as ne, a as xe } from "./Compact-8zmhZt2C.mjs";
import { A as oe } from "./AntdIcon-EfV3m8Ts.mjs";
import { o as Ie } from "./omit-B_u6A-HL.mjs";
import { S as Pe } from "./AntPagination-DhoHKg4V.mjs";
import { c as Y } from "./reactNode-CwSzDQK_.mjs";
import { B as Se } from "./button-BIXC-Zd-.mjs";
const we = (e) => {
  const {
    getPrefixCls: r,
    direction: a
  } = W(q), {
    prefixCls: t,
    className: n
  } = e, u = r("input-group", t), v = r("input"), [p, C] = ve(v), E = G(u, {
    [`${u}-lg`]: e.size === "large",
    [`${u}-sm`]: e.size === "small",
    [`${u}-compact`]: e.compact,
    [`${u}-rtl`]: a === "rtl"
  }, C, n), g = W(L), m = le(() => Object.assign(Object.assign({}, g), {
    isFormItemInput: !1
  }), [g]);
  return process.env.NODE_ENV !== "production" && Z("Input.Group").deprecated(!1, "Input.Group", "Space.Compact"), p(/* @__PURE__ */ s.createElement("span", {
    className: E,
    style: e.style,
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    onFocus: e.onFocus,
    onBlur: e.onBlur
  }, /* @__PURE__ */ s.createElement(L.Provider, {
    value: m
  }, e.children)));
}, _e = we, $e = (e) => {
  const {
    componentCls: r,
    paddingXS: a
  } = e;
  return {
    [`${r}`]: {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
      columnGap: a,
      "&-rtl": {
        direction: "rtl"
      },
      [`${r}-input`]: {
        textAlign: "center",
        paddingInline: e.paddingXXS
      },
      // ================= Size =================
      [`&${r}-sm ${r}-input`]: {
        paddingInline: e.calc(e.paddingXXS).div(2).equal()
      },
      [`&${r}-lg ${r}-input`]: {
        paddingInline: e.paddingXS
      }
    }
  };
}, Ne = fe(["Input", "OTP"], (e) => {
  const r = de(e, ge(e));
  return [$e(r)];
}, Ce);
var ze = function(e, r) {
  var a = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && r.indexOf(t) < 0 && (a[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, t = Object.getOwnPropertySymbols(e); n < t.length; n++)
      r.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[n]) && (a[t[n]] = e[t[n]]);
  return a;
};
const je = /* @__PURE__ */ s.forwardRef((e, r) => {
  const {
    value: a,
    onChange: t,
    onActiveChange: n,
    index: u,
    mask: v
  } = e, p = ze(e, ["value", "onChange", "onActiveChange", "index", "mask"]), C = a && typeof v == "string" ? v : a, E = (d) => {
    t(u, d.target.value);
  }, g = s.useRef(null);
  s.useImperativeHandle(r, () => g.current);
  const m = () => {
    pe(() => {
      var d;
      const y = (d = g.current) === null || d === void 0 ? void 0 : d.input;
      document.activeElement === y && y && y.select();
    });
  }, P = (d) => {
    let {
      key: y
    } = d;
    y === "ArrowLeft" ? n(u - 1) : y === "ArrowRight" && n(u + 1), m();
  }, x = (d) => {
    d.key === "Backspace" && !a && n(u - 1), m();
  };
  return /* @__PURE__ */ s.createElement(U, Object.assign({}, p, {
    ref: g,
    value: C,
    onInput: E,
    onFocus: m,
    onKeyDown: P,
    onKeyUp: x,
    onMouseDown: m,
    onMouseUp: m,
    type: v === !0 ? "password" : "text"
  }));
}), Re = je;
var ke = function(e, r) {
  var a = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && r.indexOf(t) < 0 && (a[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, t = Object.getOwnPropertySymbols(e); n < t.length; n++)
      r.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[n]) && (a[t[n]] = e[t[n]]);
  return a;
};
function F(e) {
  return (e || "").split("");
}
const Ae = /* @__PURE__ */ s.forwardRef((e, r) => {
  const {
    prefixCls: a,
    length: t = 6,
    size: n,
    defaultValue: u,
    value: v,
    onChange: p,
    formatter: C,
    variant: E,
    disabled: g,
    status: m,
    autoFocus: P,
    mask: x
  } = e, d = ke(e, ["prefixCls", "length", "size", "defaultValue", "value", "onChange", "formatter", "variant", "disabled", "status", "autoFocus", "mask"]);
  if (process.env.NODE_ENV !== "production") {
    const o = Z("Input.OTP");
    process.env.NODE_ENV !== "production" && o(!(typeof x == "string" && x.length > 1), "usage", "`mask` prop should be a single character.");
  }
  const {
    getPrefixCls: y,
    direction: $
  } = s.useContext(q), b = y("otp", a), R = he(d, {
    aria: !0,
    data: !0,
    attr: !0
  }), S = Ee(b), [k, M, N] = Ne(b, S), w = ne((o) => n ?? o), z = s.useContext(L), O = ye(z.status, m), h = s.useMemo(() => Object.assign(Object.assign({}, z), {
    status: O,
    hasFeedback: !1,
    feedbackIcon: null
  }), [z, O]), A = s.useRef(null), I = s.useRef({});
  s.useImperativeHandle(r, () => ({
    focus: () => {
      var o;
      (o = I.current[0]) === null || o === void 0 || o.focus();
    },
    blur: () => {
      var o;
      for (let i = 0; i < t; i += 1)
        (o = I.current[i]) === null || o === void 0 || o.blur();
    },
    nativeElement: A.current
  }));
  const V = (o) => C ? C(o) : o, [j, _] = s.useState(F(V(u || "")));
  s.useEffect(() => {
    v !== void 0 && _(F(v));
  }, [v]);
  const B = J((o) => {
    _(o), p && o.length === t && o.every((i) => i) && o.some((i, c) => j[c] !== i) && p(o.join(""));
  }), X = J((o, i) => {
    let c = me(j);
    for (let f = 0; f < o; f += 1)
      c[f] || (c[f] = "");
    i.length <= 1 ? c[o] = i : c = c.slice(0, o).concat(F(i)), c = c.slice(0, t);
    for (let f = c.length - 1; f >= 0 && !c[f]; f -= 1)
      c.pop();
    const D = V(c.map((f) => f || " ").join(""));
    return c = F(D).map((f, H) => f === " " && !c[H] ? c[H] : f), c;
  }), K = (o, i) => {
    var c;
    const D = X(o, i), f = Math.min(o + i.length, t - 1);
    f !== o && ((c = I.current[f]) === null || c === void 0 || c.focus()), B(D);
  }, Q = (o) => {
    var i;
    (i = I.current[o]) === null || i === void 0 || i.focus();
  }, l = {
    variant: E,
    disabled: g,
    status: O,
    mask: x
  };
  return k(/* @__PURE__ */ s.createElement("div", Object.assign({}, R, {
    ref: A,
    className: G(b, {
      [`${b}-sm`]: w === "small",
      [`${b}-lg`]: w === "large",
      [`${b}-rtl`]: $ === "rtl"
    }, N, M)
  }), /* @__PURE__ */ s.createElement(L.Provider, {
    value: h
  }, Array.from({
    length: t
  }).map((o, i) => {
    const c = `otp-${i}`, D = j[i] || "";
    return /* @__PURE__ */ s.createElement(Re, Object.assign({
      ref: (f) => {
        I.current[i] = f;
      },
      key: c,
      index: i,
      size: w,
      htmlSize: 1,
      className: `${b}-input`,
      onChange: K,
      value: D,
      onActiveChange: Q,
      autoFocus: i === 0 && P
    }, l));
  }))));
}), Te = Ae;
var Me = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { tag: "path", attrs: { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, name: "eye-invisible", theme: "outlined" };
const Ve = Me;
var De = function(r, a) {
  return /* @__PURE__ */ s.createElement(oe, ee({}, r, {
    ref: a,
    icon: Ve
  }));
}, se = /* @__PURE__ */ s.forwardRef(De);
process.env.NODE_ENV !== "production" && (se.displayName = "EyeInvisibleOutlined");
const Be = se;
var Fe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" };
const Le = Fe;
var qe = function(r, a) {
  return /* @__PURE__ */ s.createElement(oe, ee({}, r, {
    ref: a,
    icon: Le
  }));
}, re = /* @__PURE__ */ s.forwardRef(qe);
process.env.NODE_ENV !== "production" && (re.displayName = "EyeOutlined");
const Ge = re;
var Ue = function(e, r) {
  var a = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && r.indexOf(t) < 0 && (a[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, t = Object.getOwnPropertySymbols(e); n < t.length; n++)
      r.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[n]) && (a[t[n]] = e[t[n]]);
  return a;
};
const Xe = (e) => e ? /* @__PURE__ */ s.createElement(Ge, null) : /* @__PURE__ */ s.createElement(Be, null), Ke = {
  click: "onClick",
  hover: "onMouseOver"
}, ae = /* @__PURE__ */ s.forwardRef((e, r) => {
  const {
    disabled: a,
    action: t = "click",
    visibilityToggle: n = !0,
    iconRender: u = Xe
  } = e, v = typeof n == "object" && n.visible !== void 0, [p, C] = ce(() => v ? n.visible : !1), E = ue(null);
  s.useEffect(() => {
    v && C(n.visible);
  }, [v, n]);
  const g = be(E), m = () => {
    a || (p && g(), C((z) => {
      var O;
      const h = !z;
      return typeof n == "object" && ((O = n.onVisibleChange) === null || O === void 0 || O.call(n, h)), h;
    }));
  }, P = (z) => {
    const O = Ke[t] || "", h = u(p), A = {
      [O]: m,
      className: `${z}-icon`,
      key: "passwordIcon",
      onMouseDown: (I) => {
        I.preventDefault();
      },
      onMouseUp: (I) => {
        I.preventDefault();
      }
    };
    return /* @__PURE__ */ s.cloneElement(/* @__PURE__ */ s.isValidElement(h) ? h : /* @__PURE__ */ s.createElement("span", null, h), A);
  }, {
    className: x,
    prefixCls: d,
    inputPrefixCls: y,
    size: $
  } = e, b = Ue(e, ["className", "prefixCls", "inputPrefixCls", "size"]), {
    getPrefixCls: R
  } = s.useContext(q), S = R("input", y), k = R("input-password", d), M = n && P(k), N = G(k, x, {
    [`${k}-${$}`]: !!$
  }), w = Object.assign(Object.assign({}, Ie(b, ["suffix", "iconRender", "visibilityToggle"])), {
    type: p ? "text" : "password",
    className: N,
    prefixCls: S,
    suffix: M
  });
  return $ && (w.size = $), /* @__PURE__ */ s.createElement(U, Object.assign({
    ref: te(r, E)
  }, w));
});
process.env.NODE_ENV !== "production" && (ae.displayName = "Input.Password");
const Qe = ae;
var He = function(e, r) {
  var a = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && r.indexOf(t) < 0 && (a[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, t = Object.getOwnPropertySymbols(e); n < t.length; n++)
      r.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[n]) && (a[t[n]] = e[t[n]]);
  return a;
};
const ie = /* @__PURE__ */ s.forwardRef((e, r) => {
  const {
    prefixCls: a,
    inputPrefixCls: t,
    className: n,
    size: u,
    suffix: v,
    enterButton: p = !1,
    addonAfter: C,
    loading: E,
    disabled: g,
    onSearch: m,
    onChange: P,
    onCompositionStart: x,
    onCompositionEnd: d
  } = e, y = He(e, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd"]), {
    getPrefixCls: $,
    direction: b
  } = s.useContext(q), R = s.useRef(!1), S = $("input-search", a), k = $("input", t), {
    compactSize: M
  } = xe(S, b), N = ne((l) => {
    var o;
    return (o = u ?? M) !== null && o !== void 0 ? o : l;
  }), w = s.useRef(null), z = (l) => {
    l != null && l.target && l.type === "click" && m && m(l.target.value, l, {
      source: "clear"
    }), P == null || P(l);
  }, O = (l) => {
    var o;
    document.activeElement === ((o = w.current) === null || o === void 0 ? void 0 : o.input) && l.preventDefault();
  }, h = (l) => {
    var o, i;
    m && m((i = (o = w.current) === null || o === void 0 ? void 0 : o.input) === null || i === void 0 ? void 0 : i.value, l, {
      source: "input"
    });
  }, A = (l) => {
    R.current || E || h(l);
  }, I = typeof p == "boolean" ? /* @__PURE__ */ s.createElement(Pe, null) : null, V = `${S}-button`;
  let j;
  const _ = p || {}, B = _.type && _.type.__ANT_BUTTON === !0;
  B || _.type === "button" ? j = Y(_, Object.assign({
    onMouseDown: O,
    onClick: (l) => {
      var o, i;
      (i = (o = _ == null ? void 0 : _.props) === null || o === void 0 ? void 0 : o.onClick) === null || i === void 0 || i.call(o, l), h(l);
    },
    key: "enterButton"
  }, B ? {
    className: V,
    size: N
  } : {})) : j = /* @__PURE__ */ s.createElement(Se, {
    className: V,
    type: p ? "primary" : void 0,
    size: N,
    disabled: g,
    key: "enterButton",
    onMouseDown: O,
    onClick: h,
    loading: E,
    icon: I
  }, p), C && (j = [j, Y(C, {
    key: "addonAfter"
  })]);
  const X = G(S, {
    [`${S}-rtl`]: b === "rtl",
    [`${S}-${N}`]: !!N,
    [`${S}-with-button`]: !!p
  }, n), K = (l) => {
    R.current = !0, x == null || x(l);
  }, Q = (l) => {
    R.current = !1, d == null || d(l);
  };
  return /* @__PURE__ */ s.createElement(U, Object.assign({
    ref: te(w, r),
    onPressEnter: A
  }, y, {
    size: N,
    onCompositionStart: K,
    onCompositionEnd: Q,
    prefixCls: k,
    addonAfter: j,
    suffix: v,
    onChange: z,
    className: X,
    disabled: g
  }));
});
process.env.NODE_ENV !== "production" && (ie.displayName = "Search");
const We = ie, T = U;
T.Group = _e;
T.Search = We;
T.TextArea = Oe;
T.Password = Qe;
T.OTP = Te;
const ut = T;
export {
  ut as I
};
//# sourceMappingURL=index-Dp_V09On.mjs.map
